import React from "react";

export default function PlayStore() {
  return (
    <svg
      width="149"
      height="45"
      viewBox="0 0 149 45"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.5"
        y="1.09961"
        width="147.5"
        height="43"
        rx="4.5"
        fill="black"
      />
      <rect
        x="0.5"
        y="1.09961"
        width="147.5"
        height="43"
        rx="4.5"
        stroke="#A6A6A6"
      />
      <path
        d="M74.9479 24.526C72.3607 24.526 70.252 26.4939 70.252 29.2043C70.252 31.8982 72.3607 33.8826 74.9479 33.8826C77.5362 33.8826 79.6449 31.8982 79.6449 29.2043C79.6438 26.4939 77.5351 24.526 74.9479 24.526ZM74.9479 32.0412C73.53 32.0412 72.3079 30.8719 72.3079 29.2054C72.3079 27.5213 73.5311 26.3696 74.9479 26.3696C76.3658 26.3696 77.5879 27.5213 77.5879 29.2054C77.5879 30.8708 76.3658 32.0412 74.9479 32.0412ZM64.7025 24.526C62.1153 24.526 60.0066 26.4939 60.0066 29.2043C60.0066 31.8982 62.1153 33.8826 64.7025 33.8826C67.2908 33.8826 69.3995 31.8982 69.3995 29.2043C69.3995 26.4939 67.2908 24.526 64.7025 24.526ZM64.7025 32.0412C63.2846 32.0412 62.0625 30.8719 62.0625 29.2054C62.0625 27.5213 63.2857 26.3696 64.7025 26.3696C66.1204 26.3696 67.3425 27.5213 67.3425 29.2054C67.3436 30.8708 66.1204 32.0412 64.7025 32.0412ZM52.5167 25.9626V27.947H57.2665C57.1246 29.0635 56.7528 29.8786 56.1852 30.4451C55.4944 31.1359 54.4131 31.8982 52.5167 31.8982C49.5929 31.8982 47.3071 29.5409 47.3071 26.6171C47.3071 23.6933 49.5929 21.336 52.5167 21.336C54.0941 21.336 55.2458 21.9564 56.0961 22.7539L57.4964 21.3536C56.3084 20.2195 54.7321 19.3516 52.5167 19.3516C48.5116 19.3516 45.1445 22.612 45.1445 26.6171C45.1445 30.6222 48.5116 33.8826 52.5167 33.8826C54.6782 33.8826 56.3095 33.1731 57.5844 31.8443C58.8956 30.5331 59.3037 28.6895 59.3037 27.2012C59.3037 26.7414 59.2685 26.3157 59.197 25.9615H52.5167V25.9626ZM102.356 27.5037C101.966 26.4587 100.778 24.526 98.3504 24.526C95.9403 24.526 93.9372 26.4224 93.9372 29.2043C93.9372 31.8267 95.9227 33.8826 98.5803 33.8826C100.724 33.8826 101.965 32.5714 102.48 31.8091L100.885 30.7454C100.354 31.5253 99.6264 32.039 98.5803 32.039C97.5353 32.039 96.7906 31.5605 96.3121 30.6211L102.568 28.0339L102.356 27.5037ZM95.9755 29.0635C95.9227 27.2551 97.3758 26.3344 98.4219 26.3344C99.237 26.3344 99.9278 26.7425 100.159 27.3266L95.9755 29.0635ZM90.8902 33.5999H92.945V19.8488H90.8902V33.5999ZM87.522 25.5721H87.4516C86.9907 25.0221 86.1041 24.526 84.9887 24.526C82.649 24.526 80.5051 26.5819 80.5051 29.223C80.5051 31.8454 82.649 33.8837 84.9887 33.8837C86.1052 33.8837 86.9907 33.3876 87.4516 32.8211H87.522V33.4943C87.522 35.284 86.565 36.241 85.0239 36.241C83.7655 36.241 82.9856 35.3379 82.6666 34.5756L80.8769 35.3203C81.3906 36.56 82.7546 38.0846 85.0239 38.0846C87.434 38.0846 89.4723 36.6667 89.4723 33.2105V24.8109H87.5231V25.5721H87.522ZM85.1658 32.0412C83.7479 32.0412 82.561 30.8532 82.561 29.223C82.561 27.5741 83.7479 26.3696 85.1658 26.3696C86.565 26.3696 87.6639 27.5741 87.6639 29.223C87.6639 30.8532 86.565 32.0412 85.1658 32.0412ZM111.985 19.8488H107.067V33.5999H109.118V28.3903H111.984C114.259 28.3903 116.496 26.7436 116.496 24.1201C116.496 21.4966 114.26 19.8488 111.985 19.8488ZM112.038 26.4763H109.118V21.7628H112.038C113.572 21.7628 114.443 23.0333 114.443 24.1201C114.443 25.1849 113.572 26.4763 112.038 26.4763ZM124.723 24.5018C123.237 24.5018 121.698 25.1563 121.061 26.6072L122.883 27.3673C123.272 26.6072 123.998 26.3586 124.758 26.3586C125.82 26.3586 126.899 26.9955 126.916 28.1274V28.2693C126.545 28.057 125.748 27.7391 124.776 27.7391C122.812 27.7391 120.812 28.8182 120.812 30.8345C120.812 32.6748 122.423 33.8595 124.227 33.8595C125.606 33.8595 126.367 33.2402 126.845 32.5142H126.915V33.5757H128.897V28.3034C128.899 25.8636 127.075 24.5018 124.723 24.5018ZM124.474 32.0379C123.803 32.0379 122.865 31.7013 122.865 30.8697C122.865 29.8082 124.033 29.4012 125.042 29.4012C125.943 29.4012 126.369 29.5959 126.916 29.861C126.757 31.1359 125.66 32.0379 124.474 32.0379ZM136.116 24.8021L133.763 30.7641H133.692L131.25 24.8021H129.039L132.701 33.1346L130.613 37.77H132.754L138.398 24.8021H136.116ZM117.629 33.5999H119.681V19.8488H117.629V33.5999Z"
        fill="white"
      />
      <path
        d="M52.1609 11.8661C52.1609 12.7879 51.8881 13.5216 51.3414 14.0694C50.721 14.7206 49.9114 15.0462 48.917 15.0462C47.9644 15.0462 47.1537 14.7162 46.4882 14.0562C45.8216 13.3951 45.4883 12.5767 45.4883 11.5999C45.4883 10.622 45.8216 9.80364 46.4882 9.14364C47.1537 8.48254 47.9644 8.15254 48.917 8.15254C49.39 8.15254 49.8421 8.24494 50.2711 8.42864C50.7012 8.61344 51.0455 8.85874 51.3029 9.16564L50.7232 9.74644C50.2865 9.22394 49.6848 8.96324 48.9159 8.96324C48.2207 8.96324 47.6201 9.20744 47.113 9.69584C46.6059 10.1842 46.3529 10.8189 46.3529 11.5988C46.3529 12.3787 46.6059 13.0134 47.113 13.5018C47.6201 13.9902 48.2207 14.2344 48.9159 14.2344C49.6529 14.2344 50.2678 13.9891 50.7595 13.4974C51.0785 13.1773 51.2633 12.7318 51.3128 12.1609H48.9159V11.3678H52.1136C52.1466 11.5405 52.1609 11.7066 52.1609 11.8661Z"
        fill="white"
      />
      <path
        d="M57.232 9.1096H54.2268V11.2018H56.9372V11.9949H54.2268V14.0871H57.232V14.8989H53.3787V8.2989H57.232V9.1096Z"
        fill="white"
      />
      <path
        d="M60.808 14.8989H59.9599V9.1096H58.1163V8.2989H62.6516V9.1096H60.808V14.8989Z"
        fill="white"
      />
      <path d="M65.9328 14.8989V8.2989H66.7809V14.8989H65.9328Z" fill="white" />
      <path
        d="M70.542 14.8989H69.6939V9.1096H67.8503V8.2989H72.3856V9.1096H70.542V14.8989Z"
        fill="white"
      />
      <path
        d="M80.9708 14.0464C80.3218 14.713 79.5155 15.0463 78.5508 15.0463C77.5861 15.0463 76.7798 14.713 76.1319 14.0464C75.4829 13.3798 75.1595 12.5636 75.1595 11.5989C75.1595 10.6342 75.4829 9.81799 76.1319 9.15139C76.7798 8.48479 77.5861 8.15039 78.5508 8.15039C79.51 8.15039 80.3153 8.48589 80.9664 9.15579C81.6176 9.82569 81.9432 10.6397 81.9432 11.5989C81.9432 12.5636 81.6187 13.3798 80.9708 14.0464ZM76.7578 13.4931C77.2462 13.9881 77.8435 14.2345 78.5508 14.2345C79.2581 14.2345 79.8565 13.987 80.3438 13.4931C80.8322 12.9981 81.0775 12.3667 81.0775 11.5989C81.0775 10.8311 80.8322 10.1997 80.3438 9.70469C79.8565 9.20969 79.2581 8.96329 78.5508 8.96329C77.8435 8.96329 77.2462 9.21079 76.7578 9.70469C76.2705 10.1997 76.0252 10.8311 76.0252 11.5989C76.0252 12.3667 76.2705 12.9981 76.7578 13.4931Z"
        fill="white"
      />
      <path
        d="M83.1335 14.8989V8.2989H84.1653L87.3729 13.4326H87.4092L87.3729 12.161V8.2989H88.221V14.8989H87.3355L83.9794 9.5155H83.9431L83.9794 10.7871V14.8989H83.1335Z"
        fill="white"
      />
      <path
        d="M52.1609 11.8661C52.1609 12.7879 51.8881 13.5216 51.3414 14.0694C50.721 14.7206 49.9114 15.0462 48.917 15.0462C47.9644 15.0462 47.1537 14.7162 46.4882 14.0562C45.8216 13.3951 45.4883 12.5767 45.4883 11.5999C45.4883 10.622 45.8216 9.80364 46.4882 9.14364C47.1537 8.48254 47.9644 8.15254 48.917 8.15254C49.39 8.15254 49.8421 8.24494 50.2711 8.42864C50.7012 8.61344 51.0455 8.85874 51.3029 9.16564L50.7232 9.74644C50.2865 9.22394 49.6848 8.96324 48.9159 8.96324C48.2207 8.96324 47.6201 9.20744 47.113 9.69584C46.6059 10.1842 46.3529 10.8189 46.3529 11.5988C46.3529 12.3787 46.6059 13.0134 47.113 13.5018C47.6201 13.9902 48.2207 14.2344 48.9159 14.2344C49.6529 14.2344 50.2678 13.9891 50.7595 13.4974C51.0785 13.1773 51.2633 12.7318 51.3128 12.1609H48.9159V11.3678H52.1136C52.1466 11.5405 52.1609 11.7066 52.1609 11.8661Z"
        stroke="white"
        stroke-width="0.2"
        stroke-miterlimit="10"
      />
      <path
        d="M57.232 9.1096H54.2268V11.2018H56.9372V11.9949H54.2268V14.0871H57.232V14.8989H53.3787V8.2989H57.232V9.1096Z"
        stroke="white"
        stroke-width="0.2"
        stroke-miterlimit="10"
      />
      <path
        d="M60.808 14.8989H59.9599V9.1096H58.1163V8.2989H62.6516V9.1096H60.808V14.8989Z"
        stroke="white"
        stroke-width="0.2"
        stroke-miterlimit="10"
      />
      <path
        d="M65.9328 14.8989V8.2989H66.7809V14.8989H65.9328Z"
        stroke="white"
        stroke-width="0.2"
        stroke-miterlimit="10"
      />
      <path
        d="M70.542 14.8989H69.6939V9.1096H67.8503V8.2989H72.3856V9.1096H70.542V14.8989Z"
        stroke="white"
        stroke-width="0.2"
        stroke-miterlimit="10"
      />
      <path
        d="M80.9708 14.0464C80.3218 14.713 79.5155 15.0463 78.5508 15.0463C77.5861 15.0463 76.7798 14.713 76.1319 14.0464C75.4829 13.3798 75.1595 12.5636 75.1595 11.5989C75.1595 10.6342 75.4829 9.81799 76.1319 9.15139C76.7798 8.48479 77.5861 8.15039 78.5508 8.15039C79.51 8.15039 80.3153 8.48589 80.9664 9.15579C81.6176 9.82569 81.9432 10.6397 81.9432 11.5989C81.9432 12.5636 81.6187 13.3798 80.9708 14.0464ZM76.7578 13.4931C77.2462 13.9881 77.8435 14.2345 78.5508 14.2345C79.2581 14.2345 79.8565 13.987 80.3438 13.4931C80.8322 12.9981 81.0775 12.3667 81.0775 11.5989C81.0775 10.8311 80.8322 10.1997 80.3438 9.70469C79.8565 9.20969 79.2581 8.96329 78.5508 8.96329C77.8435 8.96329 77.2462 9.21079 76.7578 9.70469C76.2705 10.1997 76.0252 10.8311 76.0252 11.5989C76.0252 12.3667 76.2705 12.9981 76.7578 13.4931Z"
        stroke="white"
        stroke-width="0.2"
        stroke-miterlimit="10"
      />
      <path
        d="M83.1335 14.8989V8.2989H84.1653L87.3729 13.4326H87.4092L87.3729 12.161V8.2989H88.221V14.8989H87.3355L83.9794 9.5155H83.9431L83.9794 10.7871V14.8989H83.1335Z"
        stroke="white"
        stroke-width="0.2"
        stroke-miterlimit="10"
      />
      <g filter="url(#filter0_ii_483_6394)">
        <path
          d="M11.4781 8.8928C11.158 9.2316 10.9687 9.7574 10.9687 10.4383V34.7659C10.9687 35.4479 11.158 35.9726 11.4781 36.3114L11.5595 36.3906L25.1874 22.7627V22.6021V22.4415L11.5595 8.8125L11.4781 8.8928Z"
          fill="url(#paint0_linear_483_6394)"
        />
        <path
          d="M29.7294 27.3067L25.1875 22.7626V22.602V22.4414L29.7305 17.8984L29.8328 17.9567L35.2151 21.0147C36.7518 21.8881 36.7518 23.317 35.2151 24.1915L29.8328 27.2495L29.7294 27.3067Z"
          fill="url(#paint1_linear_483_6394)"
        />
        <g filter="url(#filter1_i_483_6394)">
          <path
            d="M29.8312 27.248L25.1848 22.6016L11.4766 36.3109C11.9826 36.8477 12.8197 36.9137 13.7624 36.3791L29.8312 27.248Z"
            fill="url(#paint2_linear_483_6394)"
          />
        </g>
        <path
          d="M29.8312 17.9548L13.7624 8.82476C12.8197 8.28906 11.9826 8.35616 11.4766 8.89296L25.1859 22.6023L29.8312 17.9548Z"
          fill="url(#paint3_linear_483_6394)"
        />
      </g>
      <defs>
        <filter
          id="filter0_ii_483_6394"
          x="10.9688"
          y="8.45508"
          width="25.3984"
          height="28.293"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-0.15" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_483_6394"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="0.15" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_innerShadow_483_6394"
            result="effect2_innerShadow_483_6394"
          />
        </filter>
        <filter
          id="filter1_i_483_6394"
          x="11.4766"
          y="22.6016"
          width="18.3555"
          height="14.1465"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-0.15" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_483_6394"
          />
        </filter>
        <linearGradient
          id="paint0_linear_483_6394"
          x1="23.9793"
          y1="10.1809"
          x2="5.51913"
          y2="28.6411"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#00A0FF" />
          <stop offset="0.0066" stop-color="#00A1FF" />
          <stop offset="0.2601" stop-color="#00BEFF" />
          <stop offset="0.5122" stop-color="#00D2FF" />
          <stop offset="0.7604" stop-color="#00DFFF" />
          <stop offset="1" stop-color="#00E3FF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_483_6394"
          x1="37.2154"
          y1="22.602"
          x2="10.6"
          y2="22.602"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FFE000" />
          <stop offset="0.4087" stop-color="#FFBD00" />
          <stop offset="0.7754" stop-color="#FFA500" />
          <stop offset="1" stop-color="#FF9C00" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_483_6394"
          x1="27.3079"
          y1="25.1249"
          x2="2.27353"
          y2="50.1592"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FF3A44" />
          <stop offset="1" stop-color="#C31162" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_483_6394"
          x1="8.0241"
          y1="0.794541"
          x2="19.2026"
          y2="11.9731"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#32A071" />
          <stop offset="0.0685" stop-color="#2DA771" />
          <stop offset="0.4762" stop-color="#15CF74" />
          <stop offset="0.8009" stop-color="#06E775" />
          <stop offset="1" stop-color="#00F076" />
        </linearGradient>
      </defs>
    </svg>
  );
}
